import AbstractDashboardWidget from './abstractDashboardWidget';
import { ConstructorInput } from './dashboardWidgetFactory';
import { getPropertyValue, checkNonEmptyArray, checkNonEmptyString } from '@/utils/typeChecks';

const ns = 'app.services.dynamicFiltersDashboardWidget';

export const DATA_TYPES = [
  'select',
  'string',
  'number',
  'boolean',
  'date',
  'datetime',
  'date_range',
  'datetime_range',
] as const;

export type DataType = typeof DATA_TYPES[number];

export type FilterType = {
  label: string;
  type: DataType;
  columns: string[];
  defaultValue?: string;
};

export type Configurations = {
  filters: FilterType[];
};

function assert(val: unknown): Configurations {
  if (
    typeof val !== 'object' ||
    val === null ||
    !checkNonEmptyArray(getPropertyValue(val, 'filters'), (f) => {
      return (
        typeof f === 'object' &&
        f !== null &&
        checkNonEmptyString(getPropertyValue(f, 'label')) &&
        checkNonEmptyString(getPropertyValue(f, 'type')) &&
        checkNonEmptyArray(getPropertyValue(f, 'columns'), checkNonEmptyString)
      );
    })
  ) {
    throw new Error(`${ns}.getConfigurations: filters is invalid`);
  }
  return val as Configurations;
}

export default class DynamicFiltersDashboardWidget extends AbstractDashboardWidget {
  #configurationsString: string;
  #configurations: Configurations | undefined;

  constructor(input: ConstructorInput) {
    super(input);
    this.#configurationsString = input.configurations;
  }

  getConfigurations(): Configurations {
    if (!this.#configurations) {
      this.#configurations = assert(JSON.parse(this.#configurationsString));
    }
    return this.#configurations;
  }

  setConfigurations(c: Configurations): void {
    // technically calling assert here is unnecessary, but there is a bug with AntD Form
    // where a null is allowed in an array of strings, so we need to ensure the value is valid
    // to not corrupt the database
    this.#configurations = assert(c);
  }
}
